// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1W9H7","select":"Header_select__7_3aG","clinic":"Header_clinic__S93BH"};